/**
 * Hooks to access authentication state and methods
 */

import { useContext } from "react";
import { AuthContext, type AuthContextValue } from "./auth-provider";

/**
 * Hook to access authentication state and methods.
 */
export function useAuth(): AuthContextValue {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error("useAuth must be used within an AuthProvider");
  }
  return context;
}

/**
 * Hook to check if user is authenticated.
 */
export function useIsAuthenticated(): boolean {
  const context = useContext(AuthContext);
  return context?.isAuthenticated ?? false;
}

